import { configureStore } from '@reduxjs/toolkit';

import { adminGamesApi } from '../services/api/adminGamesApi';
import { adminPromoApi } from '../services/api/adminPromoApi';
import { bannersApi } from '../services/api/bannersApi';
import { charactersApi } from '../services/api/charactersApi';
import { cpaApi } from '../services/api/cpaApi';
import { dialogsApi } from '../services/api/dialogsApi';
import { featureFlagsApi } from '../services/api/featureFlagsApi';
import { gamesApi } from '../services/api/gamesApi';
import { generateScenarioApi } from '../services/api/generateScenarioApi';
import { mediaPacksApi } from '../services/api/mediaPacksApi';
import { serviceApi } from '../services/api/serviceApi';
import { storageApi } from '../services/api/storageApi';
import { subscribeApi } from '../services/api/subscribeApi';
import { tagApi } from '../services/api/tagApi';
import { tagsCategoriesApi } from '../services/api/tagCategoriesApi';
import { tagsApi } from '../services/api/tagsApi';
import { tokenApi } from '../services/api/tokenApi';
import { usersApi } from '../services/api/usersApi';
import ScenariosReducer from './DEPRECATEDscenarios/index.js';
import sseReducer from './slices/sseSlice';
import UsersReducer from './DEPRECATEDusers';
import PrivateScenarioSlice from './privateScenario';
import PublicScenarioSlice from './publicScenario';

const baseInitialState = {
  users: {
    initialized: true,
    currentUserId: undefined,
    usersMap: new Map()
  },
  sse: {
    isConnected: false,
    error: null,
    data: null
  }
};

const reducers = {
  publicScenario: PublicScenarioSlice,
  privateScenario: PrivateScenarioSlice,
  users: UsersReducer,
  scenarios: ScenariosReducer,
  sse: sseReducer,
  [charactersApi.reducerPath]: charactersApi.reducer,
  [tagApi.reducerPath]: tagApi.reducer,
  [tagsApi.reducerPath]: tagsApi.reducer,
  [tagsCategoriesApi.reducerPath]: tagsCategoriesApi.reducer,
  [generateScenarioApi.reducerPath]: generateScenarioApi.reducer,
  [gamesApi.reducerPath]: gamesApi.reducer,
  [dialogsApi.reducerPath]: dialogsApi.reducer,
  [serviceApi.reducerPath]: serviceApi.reducer,
  [adminGamesApi.reducerPath]: adminGamesApi.reducer,
  [adminPromoApi.reducerPath]: adminPromoApi.reducer,
  [subscribeApi.reducerPath]: subscribeApi.reducer,
  [cpaApi.reducerPath]: cpaApi.reducer,
  [tokenApi.reducerPath]: tokenApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [mediaPacksApi.reducerPath]: mediaPacksApi.reducer,
  [featureFlagsApi.reducerPath]: featureFlagsApi.reducer,
  [storageApi.reducerPath]: storageApi.reducer,
  [bannersApi.reducerPath]: bannersApi.reducer
};

const apiMiddlewares = [
  charactersApi.middleware,
  tagApi.middleware,
  tagsApi.middleware,
  tagsCategoriesApi.middleware,
  generateScenarioApi.middleware,
  dialogsApi.middleware,
  gamesApi.middleware,
  serviceApi.middleware,
  adminGamesApi.middleware,
  adminPromoApi.middleware,
  subscribeApi.middleware,
  cpaApi.middleware,
  tokenApi.middleware,
  usersApi.middleware,
  mediaPacksApi.middleware,
  featureFlagsApi.middleware,
  storageApi.middleware,
  bannersApi.middleware
];

export function configureAppStore(preloadedState = {}) {
  const initialState = {
    ...baseInitialState,
    ...preloadedState
  };

  if (initialState.users?.usersMap && !(initialState.users.usersMap instanceof Map)) {
    initialState.users.usersMap = new Map(Object.entries(initialState.users.usersMap));
  }

  return configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: ['users.usersMap']
        },
        immutableCheck: false
      }).concat(...apiMiddlewares),
    preloadedState: initialState
  });
}

export type RootState = {
  [K in keyof typeof reducers]: ReturnType<typeof reducers[K]>
};
export type AppStore = ReturnType<typeof configureAppStore>;
export type AppDispatch = AppStore['dispatch']; 